import EventBus from '../../../EventBus';

export const MAP_LAYERS_FORM_EVENTS = {
  POLY_SELECTED: 'map_layers_form_poly_selected',
};

export const dispatchMapLayersFormPolySelected = (polyId: number) => {
  EventBus.dispatch(MAP_LAYERS_FORM_EVENTS.POLY_SELECTED, polyId);
};
